import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['confirmationModal', 'frequency', 'categoryName', 'trainingsCount', 'form'];

  openConfirmationModal(event) {
    let categoryId = event.target.dataset.categoryId
    let selected = $(`#select-field-${categoryId}`).val();
    this.confirmationModalTarget.dataset.elementId = event.target.id;

    if(selected != 'mixed') {
      this.trainingsCountTarget.innerHTML = event.target.dataset.trainingsCount;
      this.categoryNameTarget.innerHTML = event.target.dataset.categoryName;
      this.frequencyTarget.innerHTML = selected;
      this.confirmationModalTarget.dataset.categoryId = categoryId;
      this.confirmationModalTarget.classList.remove('hidden');
    }
  }

  closeConfirmationModal(event) {
    event.preventDefault();

    let element = $(`#${this.confirmationModalTarget.dataset.elementId}`);
    let previousValue = element.data('value');
    element.val(previousValue).trigger('change')
    this.confirmationModalTarget.classList.add('hidden')
  }

  submitConfirmationModal(event) {
    event.preventDefault();

    let parentValue = this.frequencyTarget.innerText;
    let element = $(`#${this.confirmationModalTarget.dataset.elementId}`);
    element.data('value', parentValue);
    $(`.child-select-${this.confirmationModalTarget.dataset.categoryId}`).val(parentValue).trigger('change');
    this.confirmationModalTarget.classList.add('hidden');
  }

  changedChildSelect(event) {
    let parentSelect = $(`#select-field-${event.target.dataset.categoryId}`)
    let childSelects = document.querySelectorAll(`.child-select-${event.target.dataset.categoryId}`);
    let allSame = Array.from(childSelects).every(c => c.value == event.target.value);

    parentSelect.val(allSame ? event.target.value : 'mixed');
    parentSelect.find(`option[value="${parentSelect.value}"]`).prop('selected', true);
  }

  handleManualRenewalChange() {
    this.formTarget.submit();
  }
}
